/**
 * CompareIcon/index.js
 * desc: system icon used to compare all content
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const CompareIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="compare icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.compare.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg xmlns="http://www.w3.org/2000/svg"><path d="M10.087 0c-1.27 0-2.4.8-2.82 2h-6.18v2h1.95l-2.95 7c-.47 2 1 3 3.5 3s4.06-1 3.5-3l-2.95-7h3.12c.33.85.98 1.5 1.83 1.83V17h-9v2h20v-2h-9V5.82c.85-.32 1.5-.97 1.82-1.82h3.13l-2.95 7c-.47 2 1 3 3.5 3s4.06-1 3.5-3l-2.95-7h1.95V2h-6.17c-.43-1.2-1.56-2-2.83-2zm0 2a1 1 0 110 2 1 1 0 010-2zm-6.5 5.25l1.5 3.75h-3l1.5-3.75zm13 0l1.5 3.75h-3l1.5-3.75z" /></svg>
    </IconButton>
);


export default CompareIcon;
